export enum EditableParameterType {
    text, number, enum
}